import { Component, OnInit, OnDestroy } from "@angular/core";
import { Location } from "@angular/common";
import { Store } from "@ngrx/store";
import { DateAdapter, MAT_DATE_FORMATS } from "@angular/material/core";
import {
  AppDateAdapter,
  APP_DATE_FORMATS,
} from "../../pipes/format-datepicker";
import { ActivatedRoute } from "@angular/router";
import { MatDialog, MatAutocompleteSelectedEvent } from "@angular/material";
import { FormBuilder, Validators, FormGroup, FormArray } from "@angular/forms";
import {
  AddNewTask,
  GetTaskDetails,
  UpdateTaskDetails,
  CreateSubTask,
} from "../../home/tasks/store/tasks.actions";
import { Subject } from "rxjs";
import {
  takeUntil,
  debounceTime,
  take,
  map,
  distinctUntilChanged,
} from "rxjs/operators";
import { GetShareSuggestions } from "../../home/resources/_store/resources.actions";
import { UploadDocumentDialog } from "src/app/dialogs/upload-document/upload-document-dialog.component";
import {
  GetProjectPillars,
  CreateTaskForProject,
  GetMemberRoles,
  GetProjectSteps,
  GetProjectPhases,
} from "../../home/program-dashboard/store/program-dashboard.actions";
import {
  ValidationUtil,
  VALIDATION_MESSAGES,
} from "../../../utils/validation.util";
import { GetConfigurations } from "../../home/configurations/store/configurations.actions";
import { AllDocumentsDialogComponent } from "src/app/dialogs/all-documents-dialog/all-documents-dialog.component";
import { LoaderHide } from "../../loader/store/loader.actions";
import {
  ClearViewAccess,
  CheckViewAccessGorDocStart,
} from "../../home/user-messages/_store/messages.actions";
import { DocAccessPermissionComponent } from "../doc-access-permission/doc-access-permission.component";
import { NgxPermissionsService } from "ngx-permissions";

@Component({
  selector: "create-task",
  templateUrl: "./create-task.component.html",
  styleUrls: ["./create-task.component.scss"],
  providers: [
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
  ],
})
export class CreateTaskComponent implements OnInit, OnDestroy {
  form: FormGroup;
  taskApprovers: Array<any> = [];
  supportUsers: Array<any> = [];
  attachments: Array<any> = [];
  taskOwner: any;
  noOwner: boolean = false;
  minDate;
  minDueDate = new Date();
  taskId: any;
  tags: [] = [];
  approvers: [] = [];
  viewers: [] = [];
  supporters: [] = [];
  endorsers: [] = [];
  dueDate = new Date();
  selectedApprovers = [];
  selectedEndorsers = [];
  selectedApproversIds: any = [];
  selectedValueIds: any;
  selectedEndorsersIds: any = [];
  isCreateSubtask = false;
  appr = this.fb.group({
    approverField: [""],
    // 'duplicate': false,
    // 'readOnly': false
  });
  endr = this.fb.group({
    endorserField: [""],
    // 'duplicate': false,
    // 'readonly': false
  });
  selectedIds: Array<any> = [];
  dropDownList: Array<any> = [];
  pillars$;
  steps$;
  projectId: any = "";
  memberRoles$: any;
  isAddCompliance: boolean;
  complianceType: any;
  stopper$: Subject<any> = new Subject();
  hideTag: boolean = false;
  hideTagForProject: boolean = false;
  validationMsg = VALIDATION_MESSAGES;
  taskTitleLength;
  docList = [];
  titleLengthValidationMsg: string;
  noApprover: boolean = false;
  maxTaskDate: any;
  minTaskDate: any;
  // phases: any[] = [{ id: "1", name: "phase1" }, { id: "2", name: "phase2" }]
  projectPhases: any[] = [];
  // isProcurment: boolean = false;

  control: FormArray;
  touchedRows: any;

  constructor(
    private store: Store<any>,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private ngxPermissionService: NgxPermissionsService,
    public location: Location
  ) {
    this.touchedRows = [];
    this.form = this.fb.group({
      name: [
        "",
        Validators.compose([
          Validators.required,
          ValidationUtil.cannotBeBlank,
          Validators.pattern("(.*)([a-zA-Z0-9])(.*)$"),
          // Validators.pattern('^[a-zA-Z0-9 ]+$')
        ]),
      ],
      description: ["", [Validators.maxLength(200)]],
      startDate: [""],
      dueDate: [""],
      approverArray: this.fb.array([this.appr]),
      supporterArray: this.fb.array([this.endr]),
      documents: [""],
      tags: [""],
      pillar: [""],
      step: [""],
      phase: [""],
      isProcurmentType: false, 
      // tableRows: this.fb.array([])

      // isCost: true,
      // isEstimateCost: true,
      // isAwaredCost: true,
      // isStartSceduleDate: true,
      // isCompletionSceduleDate: true,
      // procurmentType: ["",[Validators.required]],
      // cost: ["",[Validators.required]],
      // estimateCost: ["",[Validators.required]],
      // awaredCost: ["",[Validators.required]],
      // startSceduleDate: ["",[Validators.required]],
      // completionSceduleDate: ["",[Validators.required]],

    });

    // this.addRow();

    // this.form.get("isProcurmentType").valueChanges.subscribe((isProcurementType: any) => {
    //   this.toggleValidation(isProcurementType);
  
    // });



 

    this.store
      .select((state) => state.auth.user)
      .pipe(takeUntil(this.stopper$))
      .subscribe((userDetails: any) => {
        let index = userDetails.capabilities.findIndex(
          (capability) => capability === "add-tag-to-task"
        );
        // let projectIndex =userDetails.capabilities.findIndex((capability) => capability === 'add-tag-to-project');
        // console.log(index);
        if (index === -1) {
          this.hideTag = true;
        } else {
          this.hideTag = false;
        }
        this.hideTag = !Object.keys(
          this.ngxPermissionService.getPermissions()
        ).includes("add-tag-to-task");
        // if(projectIndex === -1) {
        //   this.hideTagForProject = true;
        // } else {
        //   this.hideTagForProject =false;
        // }
      });
  }

  // toggleValidation(isProcurementType: boolean) {
  //   const control = this.form.get('tableRows') as FormArray;
  //   control.controls.forEach((formGroup: FormGroup) => {
  //     if (isProcurementType) {
  //       formGroup.get('packet_name').setValidators(Validators.required);
  //       formGroup.get('packet_budget').setValidators(Validators.required);
  //     } else {
  //       formGroup.get('packet_name').clearValidators();
  //       formGroup.get('packet_budget').clearValidators();
  //     }
  //     formGroup.get('packet_name').updateValueAndValidity();
  //     formGroup.get('packet_budget').updateValueAndValidity();
  //   });
  // }


  ngOnInit() {
    this.store.dispatch(new ClearViewAccess());
    let loginId = JSON.parse(localStorage.getItem("auth")).user.details._id;
    /* check if edit mode */
    this.route.params.pipe(takeUntil(this.stopper$)).subscribe((params) => {
      this.taskId = (params || {}).taskId;
      this.isCreateSubtask = params.action === "create-subtask";
      this.isAddCompliance = params.action === "add-compliance";
      this.projectId = (params || {}).projectId || "";
      if (this.projectId.length) {
        this.store.dispatch(new GetMemberRoles(this.projectId));
        this.dropDownList = [];
      } else {
        this.minDate = new Date();
      }
      if (this.isCreateSubtask) {
        this.store.dispatch(new GetTaskDetails(this.taskId));
        this.store
          .select((state) => state.tasks.taskDetail)
          .subscribe((detail: any) => {
            this.minTaskDate = detail.startDate || detail.initialStartDate;
            this.maxTaskDate = detail.dueDate || detail.initialDueDate;
            this.form.get("startDate").setValue(new Date());
            this.form.get("dueDate").setValue(new Date(this.maxTaskDate));
          });
      }
      if (this.taskId && !this.isCreateSubtask) {
        this.store.dispatch(new GetTaskDetails(this.taskId));
        this.store
          .select((state) => state.tasks.taskDetail)
          .subscribe((detail: any) => {
            const stParts = detail.startDate.split("-");
            const dueParts = detail.dueDate.split("-");
            this.minDate = new Date(
              parseInt(stParts[0], 10),
              parseInt(stParts[1], 10) - 1,
              parseInt(stParts[2], 10)
            );
            const dueDate = new Date(
              parseInt(dueParts[0], 10),
              parseInt(dueParts[1], 10) - 1,
              parseInt(dueParts[2], 10)
            );
            if (!this.isCreateSubtask) {
              this.form.patchValue({
                name: detail.name,
                description: detail.description,
              });
              this.form.get("startDate").setValue(this.minDate);
              this.form.get("dueDate").setValue(dueDate);
            }

            this.minTaskDate = detail.initialStartDate || detail.startDate;
            this.maxTaskDate = detail.initialDueDate || detail.dueDate;
          });
      } else if (
        (!this.projectId.length || this.isAddCompliance) &&
        !this.isCreateSubtask
      ) {
        this.minTaskDate = new Date();
        this.form.get("startDate").setValue(new Date());
        this.form
          .get("dueDate")
          .setValue(new Date(new Date().getTime() + 24 * 3600 * 1000));
      }
    });

    this.route.queryParams.pipe(takeUntil(this.stopper$)).subscribe((parms) => {
      this.complianceType = parms.type;
    });

    this.store.dispatch(new GetProjectPillars());
    this.store.dispatch(new GetProjectSteps());
    this.steps$ = this.store.select((state) => state.programDashboard.steps);
    this.pillars$ = this.store.select(
      (state) => state.programDashboard.pillars
    );
    // console.log(this.projectId)
    this.store.dispatch(new GetProjectPhases(this.projectId));
    this.store
      .select((state) => state.programDashboard.projectPhases)
      .subscribe((response) => {
        if (response !== undefined) {
          const phaseList = response;
          this.projectPhases = response;
          console.log(this.projectPhases);
        }
      });

    this.memberRoles$ = this.store
      .select((state) => state.programDashboard.memberRoles)
      .pipe(
        map((roles) => {
          return roles.reduce((acc, role) => {
            if (role.key.length > 1) {
              role.key.map((key) => {
                acc.push({ ...role, key: key });
              });
            } else {
              acc.push({ ...role, key: role.key.join() });
            }
            return acc;
          }, []);
        }),
        map((roles) => {
          const rolesArray = roles.map((role) => role.key);
          return roles.map((role) => {
            if (
              rolesArray.filter((temp) => temp.includes(role.key)).length > 1
            ) {
              role["name"] = role.fullName;
            }
            return role;
          });
        })
      );
    this.form.get("startDate").valueChanges.subscribe((value) => {
      this.minDueDate = value;
    });

    if (!this.form.value.startDate) {
      this.form.get("startDate").setValue(new Date());
    }
    this.appr.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((val) => {
        // console.log(val, "value")
        if (val.approverField && val.approverField.length) {
          if (this.projectId.length) {
            this.memberRoles$.pipe(take(1)).subscribe((roles) => {
              // const rolesList = roles.filter(role => role.key !== 'Program Coordinator');
              this.dropDownList = roles
                .filter((role) => role.is_active)
                .filter((role) => {
                  return role.key
                    .toLowerCase()
                    .includes(val.approverField.trim().toLowerCase());
                });
              console.log(this.dropDownList);
            });
          } else {
            this.store.dispatch(
              new GetShareSuggestions(val.approverField.trim(), "user")
            );
          }
        }
      });
    this.endr.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((val) => {
        if (val && val.endorserField.length) {
          if (this.projectId.length) {
            this.memberRoles$.pipe(take(1)).subscribe((roles) => {
              // const rolesList = roles.filter(role => role.key !== 'Program Coordinator');
              this.dropDownList = roles
                .filter((role) => role.is_active)
                .filter((role) =>
                  role.key
                    .toLowerCase()
                    .includes(val.endorserField.trim().toLowerCase())
                );
              // this.dropDownList = roles.filter(role => role.is_active);
            });
          } else {
            this.store.dispatch(
              new GetShareSuggestions(val.endorserField.trim(), "user")
            );
          }
        }
      });

    // this.form.get('approverArray').valueChanges.subscribe((value) => {
    // console.log(value);
    // })

    // getTags(event) {
    //   console.log(event, "event");
    this.store
      .select((state) => state.resources.shareSuggestions)
      .subscribe((list) => {
        // this.dropDownList = list.filter((obj) => !this.selectedIds.includes(obj._id)).filter((obj) => obj._id !== loginId).filter((obj) => ((obj.type !== 'group') && (obj.type != 'private-group')))
        this.dropDownList = list;
      });
    this.store.dispatch(new GetConfigurations());
    this.store
      .select((state) => state.configurations.configurations)
      .pipe(takeUntil(this.stopper$))
      .subscribe((resp: any) => {
        console.log(resp);
        if (Object.keys(resp).length) {
          //     console.log("here", resp);
          // this.configObj = resp;
          this.taskTitleLength = resp["taskTitleLength"].value;
          //     const passwordMinLength = +resp['passwordMinLength'].value;
          //     const passwordMaxLength = +resp['passwordMaxLength'].value;
          this.form
            .get("name")
            .setValidators([
              Validators.required,
              ValidationUtil.cannotBeBlank,
              Validators.pattern("(.*)([a-zA-Z0-9])(.*)$"),
              Validators.maxLength(this.taskTitleLength),
            ]);
          console.log(this.taskTitleLength);
          this.titleLengthValidationMsg = `Maximum ${this.taskTitleLength} characters allowed`;
        }
      });

    //Document Access Permission popup
    this.store
      .select((state) => state.messages.viewAccessForDoc)
      .pipe(takeUntil(this.stopper$))
      .subscribe((resp) => {
        // const { noAccessDocuments, documents, ...others } = resp;
        // let users = Object.keys(others).some(key => others[key].length);

        if (resp && Object.keys(resp).length) {
          console.log(resp[0].users);
          if (resp[0].users && resp[0].users.length > 1) {
            const dialogRef = this.dialog.open(DocAccessPermissionComponent, {
              width: "700px",
              hasBackdrop: true,
              panelClass: "cmp-modal",
              data: {
                type: "create-task",
                detail: [...resp],
                // yesButtonText: 'Give access & Update task',
                // noButtonText: 'Update task without access'
              },
            });
            dialogRef.afterClosed().subscribe((response) => {
              if (response) {
                this.addTask();
                // this.store.dispatch(new UpdateTaskDetails(this.taskDetail._id, this.documentData));
              }
            });
          } else {
            this.addTask();
            // this.store.dispatch(new UpdateTaskDetails(this.taskDetail._id, this.documentData));
          }
        }
      });
  }

  // ngAfterOnInit() {
  //   this.control = this.form.get('tableRows') as FormArray;
  // }

  // initiateForm(): FormGroup {
  //   return this.fb.group({
  //     // pocketNo: ['', Validators.required],
  //     packet_name: [''],
  //     packet_budget: [''],
  //   });
  // }


  setTaskOwner(event) {
    if (!this.projectId.length) {
      // let array = event.selectedItems;
      // if (array.length) {
      //   let index = this.selectedIds.findIndex((id) => id === event.selectedItems[0]._id);
      //   if (index === -1) {
      //     this.selectedIds.push(event.selectedItems[0]._id);
      //   }
      // }
    }
    if (event.selectedItems && event.selectedItems.length) {
      this.noOwner = false;
      this.taskOwner = this.projectId.length
        ? event.selectedItems[0].value
        : event.selectedItems[0]._id;
    } else {
      this.noOwner = true;
    }
    this.dropDownList = [];
  }

  getApproverArrayControl() {
    return (this.form.get("approverArray") as FormArray).controls;
  }

  getSupporterArrayControl() {
    return (this.form.get("supporterArray") as FormArray).controls;
  }

  doSubmit() {
    if (!this.taskOwner) {
      this.noOwner = true;
      return false;
    }
    if (this.form.invalid) {
      // this.markFormGroupTouched(this.form)
      // this.toggleValidation(this.form.value.isProcurmentType);
      
      return;
    }
    const unpublishedDocsList = this.docList.filter((doc) => doc.status != 2);
    console.log(unpublishedDocsList);
    if (unpublishedDocsList.length > 0) {
      this.store
        .select((state) => state.auth.user)
        .pipe(take(1))
        .subscribe((user) => {
          if (user) {
            const userId = (user.details || {})._id;
            let checkObj = {
              userIds: Array.from(
                new Set([
                  ...this.selectedApprovers,
                  ...this.selectedEndorsers,
                  ...this.taskOwner,
                  userId,
                ])
              ),
              docIds: unpublishedDocsList.map((doc) => doc.id || doc._id),
              unique: true,
            };
            this.store.dispatch(new ClearViewAccess());
            this.store.dispatch(new CheckViewAccessGorDocStart(checkObj));
          }
        });
    } else {
      this.addTask();
    }
  }

  addTask() {
    console.log(this.form.value, "hideTag");
    let obj = {};
    obj["name"] = this.form.value.name;
    obj["description"] = this.form.value.description;
    obj["startDate"] = this.form.value.startDate;
    obj["dueDate"] = this.form.value.dueDate;
    if (!this.hideTag) {
      obj["tags"] = this.tags;
    }
    obj["projectId"] = "";
    obj["phaseId"] = this.form.value.phase;
    obj["assignee"] = this.taskOwner;
    obj["approvers"] = this.selectedApprovers;
    obj["viewers"] = this.viewers;
    obj["endorsers"] = this.selectedEndorsers;
    obj["documents"] = this.docList.map((doc: any) => doc._id || doc.id);
    obj["is_packet_available"]=this.form.value.isProcurmentType;
    // obj["proc_packet"]=this.form.value.tableRows;
    if (this.isCreateSubtask) {
      this.store.dispatch(new CreateSubTask(this.taskId, obj));
    } else if (this.taskId) {
      this.store.dispatch(new UpdateTaskDetails(this.taskId, obj));
    } else if (this.isAddCompliance) {
      obj["isCompliance"] = true;
      this.store.dispatch(
        new CreateTaskForProject(this.projectId, obj, this.complianceType)
      );
    } else if (this.projectId.length) {
      // if(!this.hideTagForProject) {
      obj["tags"] = this.tags;
      // }
      obj["pillarId"] = this.form.value.pillar.id;
      obj["stepId"] = this.form.value.step.id;
      this.store.dispatch(new CreateTaskForProject(this.projectId, obj));
    } else {
      this.store.dispatch(new AddNewTask(obj));
    }
  }

  addUser(userType: string) {
    switch (userType) {
      case "approver":
        const approver = this.form.controls.approverArray as FormArray;
        let appr = this.fb.group({
          approverField: [""],
          // 'duplicate': false,
          // 'readonly': false
        });
        // console.log( this.form.controls.approverArray)
        approver.push(appr);
        appr.valueChanges
          .pipe(debounceTime(500), distinctUntilChanged())
          .subscribe((val) => {
            // console.log(val, "value")
            if (val.approverField && val.approverField.length) {
              if (this.projectId.length) {
                this.memberRoles$.pipe(take(1)).subscribe((roles) => {
                  this.dropDownList = roles.filter((role) =>
                    role.key
                      .toLowerCase()
                      .includes(val.approverField.trim().toLowerCase())
                  );
                });
              } else {
                this.store.dispatch(
                  new GetShareSuggestions(val.approverField.trim())
                );
              }
            }
          });
        break;
      case "endorser":
        const endorser = this.form.controls.supporterArray as FormArray;
        let endr = this.fb.group({
          endorserField: [""],
          // 'duplicate': false,
          // 'readonly': false
        });
        endorser.push(endr);
        endr.valueChanges
          .pipe(debounceTime(500), distinctUntilChanged())
          .subscribe((val) => {
            if (val && val.endorserField.length) {
              if (this.projectId.length) {
                this.memberRoles$.pipe(take(1)).subscribe((roles) => {
                  this.dropDownList = roles.filter((role) =>
                    role.key
                      .toLowerCase()
                      .includes(val.endorserField.trim().toLowerCase())
                  );
                });
              } else {
                this.store.dispatch(
                  new GetShareSuggestions(val.endorserField.trim())
                );
              }
            }
          });
        break;
    }
  }

  removeUser(userType: string, index: any, formControl) {
    switch (userType) {
      case "approver":
        const approver = this.form.controls.approverArray as FormArray;
        approver.removeAt(index);

        // tslint:disable-next-line:max-line-length
        let Index = this.selectedApprovers.findIndex(
          (id) =>
            id === formControl.value.approverField._id ||
            id === formControl.value.approverField.value
        );
        if (Index > -1) {
          this.selectedApprovers.splice(Index, 1);
          this.selectedApproversIds.splice(
            this.selectedApproversIds.indexOf(
              formControl.value.approverField._id
            )
          );
        }
        this.selectedIds.splice(
          this.selectedIds.indexOf(formControl.value.approverField._id),
          1
        );
        if (!this.selectedApprovers.length) {
          this.noApprover = true;
        } else {
          this.noApprover = false;
        }
        break;
      case "endorser":
        const endorser = this.form.controls.supporterArray as FormArray;
        // endorser.removeAt(index);
        // tslint:disable-next-line:max-line-length

        /* commenting to fix issue https://transerve.atlassian.net/browse/CNW-1232, the following line gives wrong index. Always gives zero*/
        // let endIndex = this.selectedEndorsers.findIndex((id) => ((id === formControl.value.endorserField._id)||(id === formControl.value.endorserField.value)))
        let endIndex = index;
        if (endIndex > -1) {
          this.selectedEndorsers.splice(endIndex, 1);
          this.selectedEndorsersIds.splice(
            this.selectedEndorsersIds.indexOf(
              formControl.value.endorserField._id
            )
          );
        }
        endorser.removeAt(index);
        this.selectedIds.splice(
          this.selectedIds.indexOf(formControl.value.endorserField._id),
          1
        );
        break;
    }
  }

  remove(document) {
    this.docList = this.docList.filter(
      (doc) => (doc.id || doc._id) !== (document.id || document._id)
    );
  }

  getSelectedTagId(tag) {
    this.tags = tag;
  }

  selected(event: MatAutocompleteSelectedEvent, type): void {
    this.dropDownList = [];
    let index = this.selectedIds.findIndex(
      (id) => id === event.option.value._id
    );
    if (index === -1) {
      this.selectedIds.push(event.option.value._id);
    }
    switch (type) {
      case "approver":
        let approverArray = this.form.controls.approverArray as FormArray;
        if (approverArray) {
          if (this.projectId.length) {
            console.log(event.option.value);
            this.selectedApprovers.push(event.option.value.value);
            if (this.selectedApprovers.length) {
              this.noApprover = false;
            } else {
              this.noApprover = true;
            }
            return;
          }
          let counts = [];
          for (let i = 0; i < approverArray.length; i++) {
            if (counts[approverArray.value[i].endorserField] === undefined) {
              counts[approverArray.value[i].endorserField] = 1;
            } else {
              // approverArray.controls[i].value.duplicate = true;
            }
          }
        }

        // let index = this.selectedApprovers.findIndex((id) => id === event.option.value._id)
        this.selectedApprovers.push(event.option.value._id);

        // if (index === -1) {

        // }
        // else {
        //   console.log("write error case here")
        // }
        break;
      case "endorser":
        let endorserArray = this.form.controls.supporterArray as FormArray;
        if (endorserArray) {
          if (this.projectId.length) {
            console.log(event.option.value);
            this.selectedEndorsers.push(event.option.value.value);
            return;
          }
          let counts = [];
          for (let i = 0; i < endorserArray.length; i++) {
            if (counts[endorserArray.value[i].endorserField] === undefined) {
              counts[endorserArray.value[i].endorserField] = 1;
            } else {
              // endorserArray.controls[i].value.duplicate = true;
            }
          }
        }
        // let sIndex = this.selectedEndorsers.findIndex((id) => id === event.option.value._id);
        this.selectedEndorsers.push(event.option.value._id);
        // if (sIndex === -1) {

        // }
        // else {
        //   console.log('error for it')
        // }
        break;
    }
  }

  displayFnForApprover(selectedValue) {
    if (selectedValue && Object.keys(selectedValue).length) {
      // tslint:disable-next-line:max-line-length
      return selectedValue.key
        ? selectedValue.key +
            (selectedValue.name ? "(" + selectedValue.name + ")" : "")
        : (selectedValue.firstName || "") +
            " " +
            (selectedValue.middleName || "") +
            " " +
            (selectedValue.lastName || "") +
            "  ( " +
            (selectedValue.role || "") +
            " )";
    }
  }

  displayFnForEndorser(selectedValue) {
    if (selectedValue && Object.keys(selectedValue).length) {
      // tslint:disable-next-line:max-line-length
      return selectedValue.key
        ? selectedValue.key +
            (selectedValue.name ? "(" + selectedValue.name + ")" : "")
        : (selectedValue.firstName || "") +
            " " +
            (selectedValue.middleName || "") +
            " " +
            (selectedValue.lastName || "") +
            "  (" +
            (selectedValue.role || "") +
            " )";
    }
  }

  checkStatus(i, type) {
    const approver = this.form.controls.approverArray as FormArray;
    const endorser = this.form.controls.supporterArray as FormArray;
    switch (type) {
      case "approver":
        if (
          typeof approver.controls[i].get("approverField").value === "object"
        ) {
          return true;
        }
        return false;
      case "endorser":
        if (
          typeof endorser.controls[i].get("endorserField").value === "object"
        ) {
          return true;
        }
        return false;
      // tslint:disable-next-line:max-line-length
    }
  }

  removedOwner(event) {
    let id = event.removedItems[0];
    if (event.removedItems.length) {
      let index = this.selectedIds.findIndex((selectedId) => selectedId === id);
      if (index > -1) {
        this.selectedIds.splice(index, 1);
      }
    }
    this.taskOwner = "";
  }

  addNewDocument() {
    // need to implement this
    const dialogRef = this.dialog.open(UploadDocumentDialog, {
      hasBackdrop: true,
      width: "90%",
      height: "85%",
      data: {},
    });
    dialogRef.afterClosed().subscribe((document) => {
      if (document !== undefined && Object.keys(document).length) {
        if (document) {
          this.docList.push(document);
          // this.showError = false;
          this.store.dispatch(new LoaderHide());
        }
      }
    });
  }

  addExistingDocument() {
    // need to implement this.
    const dialogRef = this.dialog.open(AllDocumentsDialogComponent, {
      hasBackdrop: true,
      width: "90%",
      height: "85%",
      data: {},
    });
    dialogRef.afterClosed().subscribe((document) => {
      if (document !== undefined && Object.keys(document).length) {
        const isExisting = this.docList
          .map((docObj) => docObj.id || docObj._id)
          .filter((ind) => ind === (document.id || document._id)).length;
        if (!isExisting) {
          // this.showError = false;
          this.docList.push(document);
        } else {
          console.log("duplicate key");
        }
      }
    });
  }

  setTaskApprover() {
    console.log("selectedApprovers", this.selectedApprovers);
    if (!this.selectedApprovers.length) {
      this.noApprover = true;
    } else {
      this.noApprover = false;
    }
  }

  ngOnDestroy() {
    this.stopper$.next();
    this.stopper$.complete();
  }

  // setProcurement(i) {
  //   const control = this.form.get("tableRows") as FormArray;
  //   control.at(i).patchValue({
  //     pocketNo: i + 1,
  //   });
  //   return i + 1;
  // }

  // addRow() {
  //   const control =  this.form.get('tableRows') as FormArray;
  //   control.push(this.initiateForm());
  //   this.toggleValidation(this.form.value.isProcurmentType);
  // }

  // deleteRow(index: number) {
  //   const control =  this.form.get('tableRows') as FormArray;
  //   control.removeAt(index);
  // }

  // get getFormControls() {
  //   const control = this.form.get('tableRows') as FormArray;
  //   return control;
  // }

  // markFormGroupTouched(formGroup: FormGroup): void {
  //   (Object as any).values(formGroup.controls).forEach((control) => {
  //     control.markAsTouched();
  //     if (control.controls) {
  //       this.markFormGroupTouched(control);
  //     }
  //   });
  // }

  keyPressAlphanumeric(event) {

    var inp = String.fromCharCode(event.keyCode);

    if (/[a-zA-Z0-9 ]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

}
